import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'src/redux/store';
import axios from 'src/utility/apis/msGraphAxios';
import defaultAvatar from 'src/assets/images/avatars/avatar-blank.png';

export interface State {
    isLoading: boolean;
    error: boolean;
    account: any
    userAvatar: string;
}

const initialState: State = {
    isLoading: false,
    error: false,
    account: { displayName: 'Anonymous User' },
    userAvatar: defaultAvatar
};

const profileSlice = createSlice({
    name: 'profile',
    initialState,
    reducers: {
        startLoading: (state) => {
            state.isLoading = true;
        },
        hasError: (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        },
        getMyInfoSuccess: (state, action) => {
            state.isLoading = false;
            state.account = action.payload;
        },
        getMyAvatarSuccess: (state, action: PayloadAction<string>) => {
            state.isLoading = false;
            state.userAvatar = action.payload;
        },
    },
});

// Reducer
export default profileSlice.reducer

// Actions
export const { startLoading, hasError, getMyInfoSuccess } = profileSlice.actions;

// for useSelector
export const selectProfile = (state: RootState) => state.profile as State;

// ----------------------------------------------------------------------
export function getMyInfo() {
    return async (dispatch, getState) => {
        dispatch(profileSlice.actions.startLoading());
        try {
            const response = await axios.get('me');
            dispatch(profileSlice.actions.getMyInfoSuccess(response.data));
        } catch (error) {
            dispatch(profileSlice.actions.hasError(true));
        }
    };
}

export function getMyAvatar() {
    return async (dispatch, getState) => {
        dispatch(profileSlice.actions.startLoading());
        try {
            const response = await axios.get('me/photo/$value', { responseType: 'arraybuffer' });

            let bufferArray;
            // no photo returns "500 - Internal Server Error"
            if (response.status === 500) {
                bufferArray =new ArrayBuffer(0);
            } else {
                bufferArray = response.data;
            }
            const base64Flag = 'data:image/jpeg;base64,';

            const arrayBufferToBase64 = (buffer: ArrayBuffer): string => {
                let binary = '';
                const bytes = [].slice.call(new Uint8Array(buffer));
                bytes.forEach((b) => binary += String.fromCharCode(b));
                return window.btoa(binary);
            }
            const imageString = arrayBufferToBase64(bufferArray);
            const result = imageString.length > 0 ? base64Flag + imageString : defaultAvatar;
            dispatch(profileSlice.actions.getMyAvatarSuccess(result));
        } catch (error) {
            dispatch(profileSlice.actions.hasError(true));
        }
    };
}
